import axios from "axios";
import client from "./client";
import { API_BASE_URL } from "@/lib/constants";
import type {
  SSOConfigurationRead,
  SSOConfigurationUpsert,
  SSOIdentity,
  SSOLoginResponse,
  SSOProvider,
  SSOStatusResponse,
} from "@/types/sso";

// Separate axios client for the public discovery endpoint — no Authorization
// interceptor, so the login page works without an existing session.
const publicClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export async function getEnabledProviders(
  orgSlug: string
): Promise<SSOStatusResponse> {
  const res = await publicClient.get<SSOStatusResponse>("/auth/sso/providers", {
    params: { org: orgSlug },
  });
  return res.data;
}

export async function getAuthorizationUrl(
  provider: SSOProvider,
  orgSlug: string,
  nextPath = "/"
): Promise<SSOLoginResponse> {
  const res = await publicClient.get<SSOLoginResponse>(
    `/auth/sso/${provider}/login`,
    { params: { org: orgSlug, next: nextPath, mode: "url" } }
  );
  return res.data;
}

export async function getSSOConfig(
  provider: SSOProvider
): Promise<SSOConfigurationRead> {
  const res = await client.get<SSOConfigurationRead>(
    `/auth/sso/config/${provider}`
  );
  return res.data;
}

export async function upsertSSOConfig(
  provider: SSOProvider,
  payload: SSOConfigurationUpsert
): Promise<SSOConfigurationRead> {
  const res = await client.put<SSOConfigurationRead>(
    `/auth/sso/config/${provider}`,
    payload
  );
  return res.data;
}

export async function listMySSOIdentities(): Promise<SSOIdentity[]> {
  const res = await client.get<SSOIdentity[]>("/auth/sso/identities/me");
  return res.data;
}
